/**
 * Malawian kwacha.
 */
export var MWK = {
  code: 'MWK',
  base: 10,
  exponent: 2
};